// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopDelayedConstraints(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/top_delayed_constraints${startDate ? `?start_date=${startDate}` : ''}`);
}
